import {XauditModel} from '../xaudit.model';

export class CfgArPaymentProcessorDeviceModel extends XauditModel{
  PaymentDeviceID: string;
  PaymentProcessorId: string;
  LOCID: number;
  WorkStationId: string;
  enumARProcessorID: string;
  Description: string;
  DeviceParametersJSON: string;
  isWSdefault: boolean;
}
